import { render, staticRenderFns } from "./LearningDetail.vue?vue&type=template&id=77705839&"
import script from "./LearningDetail.vue?vue&type=script&lang=js&"
export * from "./LearningDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports